import React from "react";
import { useNavigate } from "react-router-dom";
import "./Itinerary.css";
import sigiriyaImg from "./sigiriyaRock.jpg";
import kandyImg from "./Ktemple.png";
import { useTranslation } from "./hooks/useTranslation";

const Package1Details = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBookNow = () => {
    navigate("/buy");
  };

  const packageInfo = {
    duration: t.package1Duration,
    charges: t.package1Charges,
    hotel: t.package1Hotel,
    price: t.package1Price
  };

  const locationsData = t.package1Locations || [];

  const locationImages = [
    { image: sigiriyaImg, alt: "Sigiriya" },
    { image: kandyImg, alt: "Kandy" },
  ];

  return (
    <div className="itinerary-wrapper">
      <header className="itinerary-header">
        <h1>{t.package1Title}</h1>
        <div className="package-info-section">
          <p className="intro-text">
            <strong>{packageInfo.duration}</strong>
          </p>
          <p className="intro-text">{packageInfo.charges}</p>
          <p className="intro-text">{packageInfo.hotel}</p>
          <p className="intro-text">
            <strong style={{ color: "#1a73e8", fontSize: "1.2rem" }}>
              {packageInfo.price}
            </strong>
          </p>
        </div>
      </header>

      {/* Book Now button above itinerary, right aligned */}
      <div className="book-now-wrapper top-right">
        <button className="book-now-button" onClick={handleBookNow}>
          {t.bookNow}
        </button>
      </div>

      <div className="itinerary-cards-container">
        {locationsData.map((location, index) => {
          const imageObj = locationImages[index] || {};
          return (
            <div key={index} className="itinerary-card">
              <div className="card-header">
                <div className="day-badge">{location.name}</div>
              </div>

              <div className="card-content">
                {imageObj.image && (
                  <img 
                    src={imageObj.image} 
                    alt={imageObj.alt || location.name} 
                    className="activity-image"
                  />
                )}
                <h3>{t.package1Activities}</h3>
                <div className="activity-details">
                  {location.activities.map((activity, i) => (
                    <div key={i} className="activity-item">
                      <h4 className="activity-title">{activity.title}</h4>
                      <p className="activity-desc">{activity.desc}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Package1Details;

